import { fetcher } from '@commenda/utils';
import {
  CreateJurisdictionExemption,
  ExemptionCertificateUpdateResponse,
  JurisdictionExemptionUpdateResponse,
  UpdateExemptionCertificate,
  UpsertJurisdictionExemptionBulkType,
} from './types';

export async function updateExemptionCertificate(
  certificateId: string,
  body: UpdateExemptionCertificate
): Promise<{
  success: boolean;
  data?: { data: ExemptionCertificateUpdateResponse };
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/${certificateId}`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to update exemption certificate',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function updateJurisdictionExemption(
  certificateId: string,
  jurisdictionId: string,
  body: Partial<CreateJurisdictionExemption>
): Promise<{
  success: boolean;
  data?: {
    data: JurisdictionExemptionUpdateResponse;
  };
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/${certificateId}/jurisdictions/${jurisdictionId}`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to update jurisdiction exemption',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function upsertJurisdictionExemptionBulk(
  certificateId: string,
  body: UpsertJurisdictionExemptionBulkType
): Promise<{
  success: boolean;
  data?: {
    data: JurisdictionExemptionUpdateResponse;
  };
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/${certificateId}/jurisdictions/bulk_upsert`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to update jurisdiction exemption',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
